/**
 * Created by daniesy on 16/11/2016.
 */
var d3 = require('d3');

export default class Alert {
    constructor(title, text, action, callback) {
        this.title = title;
        this.text = text;
        this.action = action;
        this.callback = callback;
    }

    drawInElement(element) {
        let that = this;
        this.alertElement = element
            .append('div')
            .attr('class', 'alert');

        let alertWrapper = this.alertElement
            .append('div')
            .attr('class', 'alert__wrapper');

        alertWrapper
            .append('img')
            .attr('src', 'assets/chart.svg');

        if (this.title) {
            alertWrapper
                .append('h3')
                .attr('class', 'alert__title')
                .text(this.title);
        }

        if(this.text) {
            alertWrapper
                .append('p')
                .attr('class', 'alert__text')
                .html(this.text);
        }

        alertWrapper
            .append('button')
            .text(this.action)
            .on('click', function() {
                that.callback(that);
            });
    }
    show(timeout = 400) {
        setTimeout(() => this.alertElement.attr('class', 'alert alert--visible'), timeout);
    }
    hide(timeout = 400) {
        this.alertElement.attr('class', 'alert');
        setTimeout(() => this.alertElement.remove(), timeout);
    }
}



// WEBPACK FOOTER //
// ./src/js/alert.js